import { useCallback } from 'react';
import { tailorsApi } from '../api';
import { useFetch } from '../hooks/useFetch';
import toast from 'react-hot-toast';

export default function Assignments() {
  const fetchAss = useCallback(() => tailorsApi.getAssignments({ completed: 'false', limit: 50 }), []);
  const { data, loading, refetch } = useFetch(fetchAss, []);
  const assignments = data?.rows || data || [];

  const complete = async (id) => {
    try {
      await tailorsApi.complete(id);
      toast.success('Marked as completed!');
      refetch();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">My Assignments</h1>
        <span className="badge badge-stitching">{assignments.length} Active</span>
      </div>

      {loading ? (
        <div className="empty-state" style={{ minHeight: '50vh' }}><div className="spinner" /></div>
      ) : assignments.length === 0 ? (
        <div className="empty-state" style={{ minHeight: '50vh' }}>
          <div className="empty-icon">✅</div>
          <h3>All caught up!</h3>
          <p>You have no pending assignments</p>
        </div>
      ) : (
        <div className="grid-3">
          {assignments.map((a) => (
            <div key={a.id} className="card">
              <div className="card-header">
                <div>
                  <div className="mono text-sm" style={{ color: 'var(--accent-light)' }}>{a.orderItem?.order?.orderNumber}</div>
                  <div className="font-semibold">{a.orderItem?.garmentType}</div>
                </div>
                <span className="badge badge-stitching">In Progress</span>
              </div>
              <div className="card-body">
                <div className="flex justify-between mb-3" style={{ fontSize: '0.85rem' }}>
                  <span className="text-muted">Customer</span>
                  <span className="font-semibold">{a.orderItem?.order?.customer?.name}</span>
                </div>
                <div className="flex justify-between mb-3" style={{ fontSize: '0.85rem' }}>
                  <span className="text-muted">Labor Pay</span>
                  <span className="font-semibold text-success">₹{Number(a.laborCost).toLocaleString('en-IN')}</span>
                </div>
                <div className="flex justify-between mb-4" style={{ fontSize: '0.85rem' }}>
                  <span className="text-muted">Assigned</span>
                  <span>{new Date(a.assignedAt).toLocaleDateString('en-IN')}</span>
                </div>
                {a.notes && <div style={{ background: 'var(--bg-elevated)', borderRadius: 'var(--radius)', padding: '0.75rem', fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '1rem' }}>{a.notes}</div>}
                <button className="btn btn-success w-full" onClick={() => complete(a.id)}>✓ Mark as Complete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
